import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { EventsService } from '../../events.service';
import { GlobalService } from '../../../global.service';
import {
  PerfectScrollbarConfigInterface,
  PerfectScrollbarComponent,
  PerfectScrollbarDirective
} from 'ngx-perfect-scrollbar';
import {Title} from "@angular/platform-browser";
declare const fireSpark: any;


@Component({
  selector: 'app-orange-ramadan-cup',
  templateUrl: './orange-ramadan-cup.component.html',
  styleUrls: ['./orange-ramadan-cup.component.css']
})
export class OrangeRamadanCupComponent implements OnInit {

  public config: PerfectScrollbarConfigInterface = {
    // suppressScrollX:true
  };
  @ViewChild(PerfectScrollbarComponent) componentRef?: PerfectScrollbarComponent;
  @ViewChild(PerfectScrollbarDirective) directiveRef?: PerfectScrollbarDirective;


  constructor(private router: Router, private activeRoute: ActivatedRoute, public eventService: EventsService,
              public globalService: GlobalService , private titleService:Title) {
    this.titleService.setTitle('Orange Ramadan Cup')
  }

  ngOnInit() {


    fireSpark();
  }

}
